// Standalone two-tone alert beep (same character as PCTile's danger alert, but
// self-contained so pages that render WITHOUT the dashboard tiles — e.g. the
// Test Lab soak — can ring an alarm too; PCTile's alarm machinery is
// module-private and unmounts with the Dashboard).

let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  try {
    if (!ctx) ctx = new AudioContext();
    // Autoplay policy parks a context in 'suspended' until a user gesture.
    if (ctx.state === 'suspended') void ctx.resume();
    return ctx;
  } catch {
    return null;
  }
}

/** Play the two-tone alert. `gain` 0..1 (default matches the tile alarm). */
export function playAlertTone(gain = 0.3) {
  const audio = getCtx();
  if (!audio || gain <= 0) return;
  try {
    const now = audio.currentTime;
    for (const offset of [0, 0.3]) {
      const osc = audio.createOscillator();
      const g = audio.createGain();
      osc.connect(g);
      g.connect(audio.destination);
      osc.frequency.value = 800;
      osc.type = 'sine';
      g.gain.value = Math.min(1, gain);
      osc.start(now + offset);
      osc.stop(now + offset + 0.2);
    }
  } catch {
    // Non-fatal: an alarm that cannot sound must never break the soak UI.
  }
}
